"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Swarm;
var _react = _interopRequireDefault(require("react"));
var _swarmplot = require("cccisd-nivo/swarmplot");
var _cccisdColorPicker = require("cccisd-color-picker");
var _Settings = _interopRequireWildcard(require("./Settings"));
var _AxisFields = require("../common/AxisFields");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Swarm(_ref) {
  var _settings$valueScale, _settings$yScale;
  var data = _ref.data,
    settings = _ref.settings;
  if (typeof settings.colors === 'string') {
    if (settings.colors === 'custom') {
      settings.colors = (0, _cccisdColorPicker.getColor)(settings.customColors);
    } else {
      settings.colors = {
        scheme: settings.colors
      };
    }
  }
  if (settings.valueScale && !((_settings$valueScale = settings.valueScale) !== null && _settings$valueScale !== void 0 && _settings$valueScale.max) && ((_settings$yScale = settings.yScale) === null || _settings$yScale === void 0 ? void 0 : _settings$yScale.max) !== 0) {
    settings.valueScale.max = 'auto';
  }
  for (var _i = 0, _Object$keys = Object.keys(_AxisFields.allAxis); _i < _Object$keys.length; _i++) {
    var _settings$allAxis$axi;
    var axis = _Object$keys[_i];
    (_settings$allAxis$axi = settings[_AxisFields.allAxis[axis].key]) === null || _settings$allAxis$axi === void 0 ? true : delete _settings$allAxis$axi.format;
  }
  var size = function size(node) {
    return (node.volume + 1) * settings.pointSize;
  };
  return /*#__PURE__*/_react["default"].createElement(_swarmplot.ResponsiveSwarmPlot, _extends({
    data: data
  }, settings, settings.showLegend ? {} : {
    legends: []
  }, {
    size: (settings === null || settings === void 0 ? void 0 : settings.size) || size,
    groups: _toConsumableArray(new Set(data.map(function (d) {
      return d.group;
    })))
  }));
}
Swarm.Settings = function (_ref2) {
  var field = _ref2.field,
    form = _ref2.form,
    children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(_Settings["default"], {
    field: field,
    form: form
  }, children);
};
Swarm.initialValues = _Settings.initialValues;